export { default } from './BlockQuizz';
